import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Grid, Tab } from "@mui/material"
import { useCallback } from "react"
import { Localized } from "@fluent/react"
import { SystemRoleReponsibilities } from "../systemRoleReponsibilities/SystemRoleReponsibilities"
import { useSearchParams } from "react-router-dom"

type FormTabs = "systemRoleReponsibilities"

export const SystemDocumentDictionaries = () => {
    const [params, setParams] = useSearchParams()
    const tab = params.get('tab') as FormTabs || 'systemRoleReponsibilities'
    const setTab = (tab: FormTabs) => {
        params.set('tab', tab)
        setParams(params, { replace: true })
    }

    const handleTabChange = useCallback((_, newTab) => {
        setTab(newTab)
    }, [])

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TabContext value={tab}>
                        <TabList onChange={handleTabChange}>
                            <Tab
                                key={0}
                                value={"systemRoleReponsibilities"}
                                label={<Localized id="role-responsibilities">_Responsibility Dictionary</Localized>} />

                        </TabList>
                        <TabPanel value="systemRoleReponsibilities">
                            <SystemRoleReponsibilities />
                        </TabPanel>
                    </TabContext>
                </Grid>
            </Grid>
        </>
    )
}
